export const disableMockGlobal = import.meta.env.VITE_DISABLE_ENDPOINTS_MOCK_GLOBAL === 'true';
export const isMMSearchDisabled = import.meta.env.VITE_DISABLE_MATCH_MAKING_SEARCH === 'true';
export const isOutreachDisabled = import.meta.env.VITE_DISABLE_OUTREACH === 'true';
export const isProfilerSearchDownloadDisabled =
  import.meta.env.VITE_DISABLE_PROFILER_SEARCH_DOWNLOAD === 'true';
export const isProfilerAdvancedCriteriaDisabled =
  import.meta.env.VITE_DISABLE_PROFILER_ADVANCED_CRITERIA === 'true';
export const isProfilerAdvancedCriteriaSituationDisabled =
  import.meta.env.VITE_DISABLE_PROFILER_ADVANCED_CRITERIA_SITUATION === 'true';
// Ownership criteria stay hidden until the backend that applies them runs on
// that environment; an older backend would ignore the keys and return unfiltered results.
export const isProfilerAdvancedCriteriaOwnershipDisabled =
  import.meta.env.VITE_DISABLE_PROFILER_ADVANCED_CRITERIA_OWNERSHIP === 'true';
export const isComparablesToProjectSaveDisabled =
  import.meta.env.VITE_DISABLE_COMPARABLES_TO_PROJECT_SAVE === 'true';
export const isIndividualsSearchDisabled =
  import.meta.env.VITE_DISABLE_INDIVIDUALS_SEARCH === 'true';
export const isAgentDocumentUploadDisabled =
  import.meta.env.VITE_DISABLE_AGENT_DOCUMENT_UPLOAD === 'true';
// Unified-filter model (single Add-filter panel + unified chip rail). Gates the
// new client-side filter UI on the Profiler search results while it rolls out.
export const isUnifiedFiltersEnabled = import.meta.env.VITE_UNIFIED_FILTERS === 'true';
